/**
 * Bucket an unknown thumbnail-pipeline error into a short tag for
 * telemetry / structured logging. Buckets:
 *
 *   - `auth-missing`           — caller had no auth token at fetch time
 *   - `canvas-taint`           — cross-origin image tainted the canvas
 *   - `font-timeout`           — fonts.ready timed out / font-related
 *   - `image-decode-timeout`   — `<img>.decode()` timed out / decode failure
 *   - `html-to-image`          — html-to-image internal failure
 *   - `unknown`                — anything else
 */
export function normalizeThumbnailError(err: unknown): string {
  const message =
    typeof err === 'string'
      ? err
      : err instanceof Error
        ? `${err.name}: ${err.message}`
        : '';
  const lower = message.toLowerCase();

  if (lower.includes('no-auth')) return 'auth-missing';
  if (lower.includes('tainted')) return 'canvas-taint';
  if (lower.includes('decode')) return 'image-decode-timeout';
  if (lower.includes('font')) return 'font-timeout';
  if (
    lower.includes('getcomputedstyle') ||
    lower.includes('oklch') ||
    lower.includes('embedresources') ||
    lower.includes('html-to-image')
  ) {
    return 'html-to-image';
  }
  return 'unknown';
}
